import { InputNumber, Select } from 'antd';
import { IBestDataset } from '../../../../../../types/analytics';
import { Label } from '../../../../../common/Label/Label';
import { advancedAnalyticsMonthOptions } from '../../../../ResultPanel/Plot/MonthOptions';
import styles from '../../Layout/AnalyticsLayout.module.scss';

interface ScatterTableAdditionalInputProps {
  datasets: IBestDataset[];
  categories: string[];
  datasetY: string | null;
  onDatasetYChange: (value: string) => void;
  isChangeDatasetY: boolean;
  variablesY: any[];
  tempVariableY: any;
  onVariableYChange: (value: any) => void;
  intervalX: number;
  onChangeIntervalX: (value: number | null) => void;
  intervalY: number;
  onChangeIntervalY: (value: number | null) => void;
  month: any;
  onMonthChange: (value: any) => void;
  isLoading: boolean;
  hasError: boolean;
  isOfflineDataset: boolean;
}

export default function ScatterTableAdditionalInput({
  datasets,
  categories,
  datasetY,
  onDatasetYChange,
  isChangeDatasetY,
  variablesY,
  tempVariableY,
  onVariableYChange,
  intervalX,
  onChangeIntervalX,
  intervalY,
  onChangeIntervalY,
  month,
  onMonthChange,
  isLoading,
  isOfflineDataset,
}: ScatterTableAdditionalInputProps) {
  return (
    <div className={styles.additionalControlsContainer}>
      <div className={styles.controlItem}>
        <Label label='Dataset Y'>
          <Select
            id='Analytics-ScatterTable-DatasetY_Input'
            value={datasetY}
            style={{ width: '100%' }}
            onChange={onDatasetYChange}
            disabled={isOfflineDataset || isChangeDatasetY || isLoading}
          >
            {categories.map((category: string) => (
              <Select.OptGroup key={category} label={category}>
                {datasets
                  .filter((item) => item.label === category)
                  .map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.value}
                    </Select.Option>
                  ))}
              </Select.OptGroup>
            ))}
          </Select>
        </Label>
      </div>
      <div className={styles.controlItem}>
        <Label label='Variable Y'>
          <Select
            id='Analytics-ScatterTable-VariableY_Input'
            value={tempVariableY?.Index ? tempVariableY.Index : 0}
            style={{ width: '100%' }}
            onChange={onVariableYChange}
            disabled={isOfflineDataset || isLoading}
          >
            {variablesY
              .filter((item) => item.Name !== 'Time')
              .map((item) => (
                <Select.Option key={item.Index} value={item.Index}>
                  {item.Name}
                </Select.Option>
              ))}
          </Select>
        </Label>
      </div>
      <div className={styles.controlItem}>
        <Label label='Number of Intervals X'>
          <InputNumber
            id='Analytics-ScatterTable-IntervalsX_Input'
            min={1}
            max={40}
            value={intervalX}
            style={{ width: '100%' }}
            onChange={onChangeIntervalX}
            disabled={isOfflineDataset || isLoading}
          />
        </Label>
      </div>
      <div className={styles.controlItem}>
        <Label label='Number of Intervals Y'>
          <InputNumber
            id='Analytics-ScatterTable-IntervalsY_Input'
            min={1}
            max={40}
            style={{ width: '100%' }}
            onChange={onChangeIntervalY}
            value={intervalY}
            disabled={isOfflineDataset || isLoading}
          />
        </Label>
      </div>
      <div className={styles.controlItem}>
        <Label label='Month'>
          <Select
            id='Analytics-ScatterTable-Month_Input'
            style={{ width: '100%' }}
            onChange={onMonthChange}
            options={advancedAnalyticsMonthOptions}
            disabled={isOfflineDataset || isLoading}
            value={month}
          />
        </Label>
      </div>
    </div>
  );
}
